import { TextContentComponent } from '@myriadgenetics/mgh-types';
import React from 'react';
import './index.scss';

type PatientNameProps = {
  type: 'TEXT_CONTENT';
  compDef: TextContentComponent;
  responses: any;
};

export const PatientName = (props: PatientNameProps) => {
  if (!props.compDef.data.contentKey) {
    return null;
  }
  if (!props.responses?.patient?.firstName) {
    return null;
  }

  return <div className="patient-name">{props.responses?.patient?.firstName.trim()},</div>;
};

export default PatientName;
